export default "__VITE_ASSET__PhPyIfAu__"